<icc-list [tabs]="colorGroups" searchable="true" [items]="colors"  (select)="selectFillingColor($event)" [selected]='selectedColor' [itemTemplate]="'itemColor'"></icc-list>
